import * as Yup from 'yup';

export const PasswordUpdateSchema = Yup.object().shape({
  OldPassword: Yup.string().required('Old Password is required'),
  NewPassword: Yup.string()
    .required('New Password is required')
    .min(6, 'Password must be at least 6 characters'),
});
